<template>
  <div>
    <v-card
      :class="[
        {
          'red lighten-1':
            selected.fecha_baja != null && selected.fecha_baja != ''
        },
        {
          'green lighten-3':
            selected.fecha_baja == null || selected.fecha_baja == ''
        }
      ]"
    >
      <v-card-text>
        <v-row no-gutters>
          <span>
            <h3>
              {{ selected.apellido_y_nombre.toUpperCase() }} -
              {{ afiparent }} ({{ edad }})
            </h3>
          </span>
          <span>
            <cboConvenio
              readonly
              v-model="selected.id_convenio_prestacional"
              texto
            ></cboConvenio>
          </span>
          <span class="mx-2"> - </span>
          <span
            ><cboPlan
              readonly
              texto
              :id_convenio="selected.id_convenio_prestacional"
              v-model="selected.id_plan"
            ></cboPlan>
          </span>
          <span class="mx-2"> - </span>
          <span>
            <cboLocalidades texto readonly v-model="localidad"></cboLocalidades>
          </span>
          <span class="mx-2"> - </span>
          <span>
            <provSeleccionada
              :value="selected.id_provincia"
              readonly
              texto
            ></provSeleccionada>
          </span>
        </v-row>
        <v-row
          no-gutters
          v-if="selected.id_tipo_afiliacion == 1 || discapacitado"
        >
          <span>
            <h2>Coseguro Exceptuado por :</h2>
          </span>
          <span class="mx-2 red--text" v-if="discapacitado">
            <h2>DISCAPACIDAD</h2>
          </span>
          <span
            class="mx-2 red--text"
            v-if="discapacitado && selected.id_tipo_afiliacion == 1"
          >
            <h2>-</h2>
          </span>
          <span class="mx-2 red--text" v-if="selected.id_tipo_afiliacion == 1">
            <h2>
              <cboTipo_Afiliacion
                soloTexto
                v-model="selected.id_tipo_afiliacion"
              ></cboTipo_Afiliacion>
            </h2>
          </span>
        </v-row>
      </v-card-text>
    </v-card>
    <v-tabs v-model="tab" dark background-color="primary">
      <v-tab
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
        :disabled="desabilitado"
      >
        <v-icon left>mdi-medical-bag</v-icon>
        <span v-if="motivoDesabilitado == ''"> Nueva Autorizacion </span>
        <span v-if="motivoDesabilitado != ''">
          {{ motivoDesabilitado }}
        </span>
      </v-tab>
      <v-tab
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
        :disabled="desabilitado"
      >
        <v-icon left>mdi-medical-bag</v-icon>
        <span v-if="motivoDesabilitado == ''"> Orden De Laboratorio </span>
        <span v-if="motivoDesabilitado != ''">
          {{ motivoDesabilitado }}
        </span>
      </v-tab>
      <v-tab
        v-if="
          selected.id_afiliado != -1 && selected.id_afiliado != 0 && !micrositio
        "
        :disabled="desabilitado"
      >
        <v-icon left>mdi-medical-bag</v-icon>
        <span v-if="motivoDesabilitado == '' && !micrositio">
          Practicas multiples
        </span>
        <span v-if="motivoDesabilitado != '' && !micrositio">
          {{ motivoDesabilitado }}
        </span>
      </v-tab>
      <v-tab
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
        :disabled="desabilitado"
      >
        <v-icon left>mdi-ambulance</v-icon>
        Internacion
      </v-tab>
      <v-tab v-if="selected.id_afiliado != -1">
        <v-icon left>mdi-account</v-icon>
        Datos
      </v-tab>
      <v-tab v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0">
        <v-icon left>mdi-human-female-boy</v-icon>
        <v-badge color="orange" :content="GrupoFamiliar.length"
          >Grupo Familiar</v-badge
        >
      </v-tab>
      <v-tab v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0">
        <v-icon left>mdi-view-list-outline</v-icon>
        Historial
      </v-tab>
      <v-tab-item
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
      >
        <altaPractica
          :efectorlogueado="efectorlogueado"
          @practicaGuardada="
            IdImagenes = new Date().getTime()
            traerAutorizaciones
          "
          v-if="!desabilitado"
          class="pt-3"
          :id_afiliado="selected.id_afiliado"
          :patologias="selected.PatologiasBeneficiarios"
          :id_plan="selected.id_plan"
          :IdImagenes="IdImagenes"
        ></altaPractica>
      </v-tab-item>
      <v-tab-item
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
      >
        <altaLaboratorio
          :efectorlogueado="efectorlogueado"
          @practicaGuardada="
            IdImagenes = new Date().getTime()
            traerAutorizaciones
          "
          class="pt-3"
          :id_afiliado="selected.id_afiliado"
          :id_plan="selected.id_plan"
          :patologias="selected.PatologiasBeneficiarios"
          :IdImagenes="IdImagenes"
        ></altaLaboratorio>
      </v-tab-item>
      <v-tab-item
        v-if="
          selected.id_afiliado != -1 && selected.id_afiliado != 0 && !micrositio
        "
      >
        <altaMultiples
          :efectorlogueado="efectorlogueado"
          @practicaGuardada="
            IdImagenes = new Date().getTime()
            traerAutorizaciones
          "
          class="pt-3"
          :id_afiliado="selected.id_afiliado"
          :id_plan="selected.id_plan"
          :patologias="selected.PatologiasBeneficiarios"
          :IdImagenes="IdImagenes"
        ></altaMultiples>
      </v-tab-item>
      <v-tab-item
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
      >
        <altaInternacion
          :efectorlogueado="efectorlogueado"
          @practicaGuardada="
            IdImagenes = new Date().getTime()
            traerAutorizaciones
          "
          v-if="!desabilitado"
          class="pt-3"
          :id_afiliado="selected.id_afiliado"
          :id_plan="selected.id_plan"
          :IdImagenes="IdImagenes"
          :patologias="selected.PatologiasBeneficiarios"
          :modificaInternacion="modificaInternacion"
        ></altaInternacion>
      </v-tab-item>

      <v-tab-item v-if="selected.id_afiliado != -1">
        <MostrarDatos :beneficiario="selected"></MostrarDatos>
      </v-tab-item>
      <v-tab-item
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
      >
        <listaGrupo grupo></listaGrupo>
      </v-tab-item>
      <v-tab-item
        v-if="selected.id_afiliado != -1 && selected.id_afiliado != 0"
      >
        <historial
          vertodas
          v-if="!practicaselected"
          :items="listaAfiliado"
          v-model="practicaselected"
        ></historial>
        <v-col md="12">
          <practica
            readonly
            v-if="practicaselected"
            :solic="practicaselected"
            @guardado="practicaselected = undefined"
          ></practica>
        </v-col>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

//import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";

import listaGrupo from '@/components/Beneficiarios/ListaAfiliados'
import MostrarDatos from '@/components/Beneficiarios/MostrarDatos'

import altaPractica from '@/components/Practica/Alta'
import altaInternacion from '@/components/Practica/AltaInternacion'
import altaLaboratorio from '@/components/Practica/AltaLaboratorios'
import altaMultiples from '@/components/Practica/AltaMultiples'

import lista from '@/components/Practica/ListaPorBeneficiario'
import historial from '@/components/Practica/Lista'
import practica from '@/components/Practica/Practica'

import cboConvenio from '@/components/ConveniosPrestacionales/Combo'
import cboPlan from '@/components/Planes/Combo'
import API from '@/lib/API'
import LUM from '@/lib/LUM'

import provSeleccionada from '@/components/Provincias/Combo'
import cboLocalidades from '@/components/Localidades/Combo'
import cboTipo_Afiliacion from '@/components/Tipo_afiliacion/Combo'

import { mapState, mapActions } from 'vuex'
export default {
  directives: { mask },
  props: {
    titulo: String,
    readonly: {
      type: Boolean,
      default: false
    },
    Alta: {
      type: Boolean,
      default: false
    },
    modificaInternacion: {
      type: Boolean,
      default: false
    },
    DarAltaTitular: {
      type: Boolean,
      default: false
    },
    deshabilitar: {
      type: Boolean,
      default: false
    },
    efectorlogueado: {
      type: Object,
      default: null
    },
    micrositio: {
      type: Boolean,
      default: false
    }
  },
  components: {
    altaPractica,
    altaInternacion,
    altaLaboratorio,
    altaMultiples,
    cboConvenio,
    cboLocalidades,
    cboPlan,
    cboTipo_Afiliacion,
    listaGrupo,
    lista,
    historial,
    MostrarDatos,
    practica,
    provSeleccionada
  },
  computed: {
    titular() {
      return this.GrupoFamiliar.find((x) => x.parent == 0)
    },
    afiparent() {
      return this.selected.nro_afi + '/' + this.selected.parent
    },
    localidad: {
      get: function () {
        return {
          id_localidad: this.selected.id_localidad,
          codigo_postal: this.selected.codigo_postal,
          id_provincia: this.selected.id_provincia
        }
      },
      set: function (newValue) {
        this.selected.id_localidad = newValue.id_localidad
        this.selected.id_provincia = newValue.id_provincia
      }
    },
    listaAfiliado() {
      let ret = []
      if (this.ListaPorAfiliado) {
        let lst = this.ListaPorAfiliado?.filter((x) => x.tipo != 5)
        // lst.sort(LUM.dynamicSort("-id_solic"));
        lst.sort(LUM.dynamicSort('-fecha'))
        ret = lst
      }
      return ret
    },
    edad() {
      let ret = ''
      if (this.selected.fecha_nacimiento) {
        let anios = LUM.edad(
          new Date(this.selected.fecha_nacimiento.replace(/-/g, ','))
        )
        if (anios || anios == 0) {
          ret = anios + (anios == 1 ? ' año' : ' años')
        }
      }
      return ret
    },
    ...mapState('autorizaciones', ['ListaPorAfiliado']),
    ...mapState('beneficiarios', [
      'Lista',
      'Seleccionado',
      'Nuevo',
      'GrupoFamiliar'
    ]),
    desabilitado() {
      return (
        (this.deshabilitar ||
          (this.selected.fecha_fin_cobertura != null &&
          this.selected.fecha_fin_cobertura != '' &&
          this.selected.fecha_fin_cobertura < this.hoy) ||
        this.selected.id_plan == null ||
        API.Planes.desregulados.findIndex((x) => x == this.selected.id_plan) >
          -1 ||
        this.selected.fecha_alta > this.hoy)
      )
    },
    motivoDesabilitado() {
      let ret = ''
      if (this.selected.fecha_baja != null && this.selected.fecha_baja != '') {
        if (this.selected.fecha_baja <= this.hoy) {
          ret += 'De Baja '
        }
        if (
          this.selected.fecha_fin_cobertura != null &&
          this.selected.fecha_fin_cobertura != ''
        ) {
          if (this.selected.fecha_fin_cobertura > this.hoy) {
            ret = ''
          }
        }
      }
      if (this.selected.id_plan == null) {
        ret += 'Afiliado sin plan'
      }
      if (this.selected.fecha_alta > this.hoy) {
        ret += 'Afiliado con alta futura'
      }

      if (
        API.Planes.desregulados.findIndex((x) => x == this.selected.id_plan) >
        -1
      ) {
        ret += 'Afiliado desregulado'
      }
      return ret
    },
    estado() {
      let deAlta = {
        color: 'success',
        icon: 'mdi-check',
        content: '',
        valor: 'de Alta'
      }
      if (this.selected.fecha_fin_cobertura) {
        deAlta = {
          color: 'warning',
          icon: '',
          content: 'fc',
          valor: 'fin de cobertura'
        }
      }
      if (this.selected.fecha_baja) {
        deAlta = {
          color: 'error',
          icon: 'mdi-close',
          content: '',
          valor: 'de Baja'
        }
      }

      return {
        deAlta
      }
    },
    selected() {
      return this.Seleccionado
    },
    hoy() {
      return LUM.datetoYYYYMMDD(new Date())
    }
  },
  methods: {
    ...mapActions('autorizaciones', [
      'traerPorAfiliado',
      'traerPorAfiliadoyEfector'
    ]),
    traerAutorizaciones() {
      if (this.efectorlogueado) {
        this.traerPorAfiliadoyEfector({
          id_afiliado: this.Seleccionado.id_afiliado,
          id_efector: this.efectorlogueado.Id
        })
      } else {
        this.traerPorAfiliado(this.Seleccionado.id_afiliado)
      }
    },
    async evaluarDiscapacitado() {
      let ret = false
      let certs = await API.Certificados_Afiliados.traerPorAfiliado(
        this.selected.id_afiliado
      )
      if (certs) {
        ret =
          certs.findIndex(
            (x) =>
              x.tipo_certificado == 2 &&
              (!x.fecha_vencimiento ||
                new Date(x.fecha_vencimiento.replace(/-/g, ',')) > new Date())
          ) > -1
      }
      this.discapacitado = ret
    }
  },
  data() {
    return {
      practicaselected: undefined,
      tab: null,
      valid: false,
      discapacitado: false,
      requeridoRules: [(v) => !!v || '* requerido'],
      altaTitular: false,
      altaFamilar: false,
      constancia: false,
      constanciaindividual: false,
      confirmarconstancia: false,
      credencialProv: false,
      credencialProvFecha: false,
      fechacredencialprovisoria: '',
      IdImagenes: 0
    }
  },
  watch: {
    Seleccionado() {
      this.tab = 0
      this.traerAutorizaciones()
    },
    async selected() {
      this.evaluarDiscapacitado()
    }
  },
  mounted() {
    this.IdImagenes = new Date().getTime()
    this.traerAutorizaciones()
    this.evaluarDiscapacitado()
  }
}
</script>

<style>
.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 45%;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
